import { useEffect, useRef } from 'react';
import { HEARTBEAT_MS } from '../utils';

/**
 * Calls `onBeat` every `HEARTBEAT_MS` while `active`. The latest `onBeat` is
 * used, so a changing callback never restarts the interval.
 */
export const useHeartbeat = (active: boolean, onBeat: () => void) => {
  const onBeatRef = useRef(onBeat);
  useEffect(() => {
    onBeatRef.current = onBeat;
  }, [onBeat]);

  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => onBeatRef.current(), HEARTBEAT_MS);
    return () => clearInterval(id);
  }, [active]);
};
